import React from 'react';

import type { IconType } from '@fmbt/ui/icons';

import CloudRainIcon from './cloudRainIcon.svg?react';

const FarmbotCloudRainIcon: IconType = ({ size, color }) => {
  return <CloudRainIcon width={size ?? 18} height={size} color={color} />;
};

export default FarmbotCloudRainIcon;
